import { AdmissionGroup } from '@domain/admission-group';
import { useGenericQuery } from '@hooks/use-generic-query';
import { request } from '@utils/request/request';
import { RequestError, RequestMethod } from '@utils/request/request.type';

import { QUERY_KEYS } from './constants.type';
import type { EventGroupsParams } from './use-get-admission-groups.type';

export const createEventGroupsKey = (eventId: string) => {
  return [QUERY_KEYS.eventGroups, eventId];
};

const getAdmissionGroups = async ({ eventId }: EventGroupsParams) => {
  const url = `${import.meta.env.VITE_OFFERS_HOST}/v1/nightgraph/events/${eventId}/offer-groups`;

  const data: AdmissionGroup[] = await request({ url, method: RequestMethod.GET });

  return data.map((group) => ({
    ...group,
    items: [...group.items].sort((a, b) => a.position - b.position),
  }));
};

export const useGetAdmissionGroups = ({ eventId, options }: EventGroupsParams) => {
  return useGenericQuery<AdmissionGroup[], RequestError>(
    createEventGroupsKey(eventId),
    () => getAdmissionGroups({ eventId }),
    options
  );
};
